import React from 'react';
import Grid from '@material-ui/core/Grid'
import {DateInput, required, SelectInput, TextInput} from 'react-admin';
import moment from "moment";
import axiosInstance from "../../api/axios";

const useFoodMenus = (recordId) => {
    const [choices, setChoices] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);

    React.useEffect(() => {
        let mounted = true;

        if (!recordId) {
            setChoices([]);
            setLoading(false);
            return;
        }

        setLoading(true);
        setError(null);
        axiosInstance.get(`/api/mealRegistrations/foods/${recordId}`)
            .then((res) => {
                if (!mounted) return;
                setChoices(res.data || []);
            })
            .catch((e) => {
                if (!mounted) return;
                setChoices([]);
                setError(e);
            })
            .finally(() => {
                if (!mounted) return;
                setLoading(false);
            });

        return () => {
            mounted = false;
        };
    }, [recordId]);

    return {choices, loading, error};
};
const MealRegistrationFields = props => {
    const record = props.record || {};
    const {eatDate, finalizeDate, canEdit} = record;

    const disabled =
        !!finalizeDate &&
        moment(eatDate).isSameOrBefore(moment(finalizeDate));

    const recordId = record.id;

    const {choices, loading} = useFoodMenus(recordId);

    if (loading) return null;

    return (
        <>
            <Grid item sm={12}>
                {canEdit ? (
                    disabled && (
                        <b style={{color: "red"}}>
                            (*) Không thể chỉnh sửa dữ liệu đã chốt. Ngày chốt:{" "}
                            {moment(finalizeDate).format("DD-MM-YYYY")}
                        </b>
                    )
                ) : (
                    <b style={{color: "red"}}>
                        (*) Không thể chỉnh sửa dữ liệu chưa hết thời gian đăng ký thực đơn
                    </b>
                )}
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextInput source="customerName" disabled validate={required()} {...props} />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextInput source="baseUnitName" disabled validate={required()} {...props}/>
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextInput source="unitName" disabled validate={required()} {...props} />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectInput
                    source="regisFoodMenu"
                    disabled
                    validate={required()}
                    choices={choices}
                    optionValue="id"
                    optionText="name"
                    {...props}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectInput
                    source="takenFoodMenu"
                    disabled
                    choices={choices}
                    optionValue="id"
                    optionText="name"
                    {...props}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <SelectInput
                    source="changedFoodMenu"
                    disabled={disabled || !canEdit}
                    choices={choices}
                    optionValue="id"
                    optionText="name"
                    {...props}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <TextInput
                    source="changeReason"
                    disabled={disabled || !canEdit} {...props}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <DateInput source="eatDate" disabled  {...props}/>
            </Grid>
        </>
    );
};

export default MealRegistrationFields;
